import { defineMessages } from "react-intl";
import { validator } from "lib/build/forms/ltx/phase-i/medical-history/comorbidities/surgicalProcedures";
import {
	FieldData,
	FieldGroupListData,
	FieldsetData
} from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	surgicalProcedures: {
		id: "form.surgical_procedures",
		defaultMessage: "Műtétek"
	},
	surgicalProcedureName: {
		id: "form.surgical_procedures.name",
		defaultMessage: "Műtét neve"
	},
	dateOfSurgicalProcedure: {
		id: "form.surgical_procedures.date",
		defaultMessage: "Műtét dátuma"
	},
	surgicalProcedureType: {
		id: "form.surgical_procedures.type",
		defaultMessage: "Műtét"
	}
});

const surgicalProcedureNameField: FieldData = {
	type: "field",
	path: ["surgicalProcedureName"],
	label: messages.surgicalProcedureName,
	errorMessages: genericErrorMessages,
	input: { type: "input", props: { type: "text" } }
};

const dateOfSurgicalProcedureField: FieldData = {
	type: "field",
	path: ["dateOfSurgicalProcedure"],
	label: messages.dateOfSurgicalProcedure,
	errorMessages: genericErrorMessages,
	input: { type: "input", props: { type: "date" } }
};

const surgicalProcedureType: FieldGroupListData = {
	type: "field-group-list",
	path: ["surgicalProcedureType"],
	label: messages.surgicalProcedureType,
	rows: [
		{
			columns: [
				{ width: 6, field: surgicalProcedureNameField },
				{ width: 6, field: dateOfSurgicalProcedureField }
			]
		}
	]
};

const fieldset: FieldsetData = {
	rows: [{ columns: [{ width: 12, field: surgicalProcedureType }] }]
};

export const node: LeafNode = {
	id: "surgicalProcedures",
	value: {
		title: messages.surgicalProcedures,
		validator,
		fieldset,
		applyCurrentDate: true
	}
};
